import React, { forwardRef, ReactElement } from 'react';
import { Range } from 'react-range';
import {
  InputRangePrefix,
  InputRangePrefixWithSliderStyle,
  InputRangeThumb,
  InputRangeTopRight,
  InputRangeTrackHolder,
  InputRangeTrackTrack,
  InputRangeWrapper,
} from './Forms.styled';
import { toRemStr } from '../../../utils/helpers';

export type GlobalInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'disabled' | 'onChange' | 'defaultValue'
> & {
  min?: number;
  step?: number;
  max: number;
  prefix?: string;
  disabled?: boolean;
  prefixType?: 'small' | 'big';
  color: string;
  textColor?: string;
  onChange: (values: number) => void;
  showMaxTopRight?: boolean;
};

export default forwardRef<Range, GlobalInputProps>(function InputRange(
  {
    color = 'var(--greenprimary)',
    textColor = 'var(--white)',
    prefixType = 'small',
    disabled,
    className,
    min = 0,
    max,
    prefix,
    onChange,
    value,
    step = 1,
    showMaxTopRight = false,
  },
  ref,
): ReactElement {
  const valueTopped = value && Number(value) > max ? max : value;
  return (
    <InputRangeWrapper className={className} showMaxTopRight={showMaxTopRight}>
      <InputRangePrefixWithSliderStyle>
        {Boolean(prefix) && (
          <InputRangePrefix prefixType={prefixType}>{prefix}</InputRangePrefix>
        )}
        <InputRangeTrackHolder>
          <InputRangeTrackTrack />
          {max !== 0 && (
            <InputRangeTrackTrack
              style={{
                backgroundColor: color,
              }}
            />
          )}
          <div
            style={{
              margin: `0 ${toRemStr(10)}`,
            }}
          >
            {max > min ? (
              <Range
                disabled={disabled}
                ref={ref}
                max={max}
                step={step}
                min={min}
                values={[valueTopped as number]}
                onChange={([values]) => {
                  onChange(values);
                }}
                renderTrack={({ props, children }) => {
                  return (
                    <div
                      {...props}
                      style={{
                        height: 'var(--s2)',
                      }}
                    >
                      {children}
                    </div>
                  );
                }}
                renderThumb={({ props, value }) => {
                  return (
                    <InputRangeThumb
                      {...props}
                      color={color}
                      textColor={textColor}
                    >
                      {value}
                    </InputRangeThumb>
                  );
                }}
              />
            ) : (
              <InputRangeThumb
                style={{
                  zIndex: 0,
                  position: 'absolute',
                  bottom: -6,
                  left: -0.5,
                  cursor: 'not-allowed',
                }}
                color={'var(--disabled)'}
                textColor={'var(--textprimary)'}
              >
                {value}
              </InputRangeThumb>
            )}
          </div>
        </InputRangeTrackHolder>
      </InputRangePrefixWithSliderStyle>
      {showMaxTopRight && <InputRangeTopRight> {max}</InputRangeTopRight>}
    </InputRangeWrapper>
  );
});
